var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetricIconYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 22H9.33325C6.33325 22 4.33325 20 4.33325 17V7C4.33325 4 6.33325 2 9.33325 2H16.3333C19.3333 2 21.3333 4 21.3333 7V17C21.3333 20 19.3333 22 16.3333 22Z",
    stroke: "#EBAC00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 9.89922C10.8333 10.6692 11.4333 11.2992 12.1633 11.2992H13.6633C14.3033 11.2992 14.8233 10.7492 14.8233 10.0792C14.8233 9.34922 14.5033 9.08922 14.0333 8.91922L11.6333 8.07922C11.1533 7.90922 10.8333 7.64922 10.8333 6.91922C10.8333 6.24922 11.3533 5.69922 11.9933 5.69922H13.4933C14.2333 5.70922 14.8333 6.32922 14.8333 7.09922",
    stroke: "#EBAC00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 11.3496V12.0896",
    stroke: "#EBAC00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 4.91016V5.69016",
    stroke: "#EBAC00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33325 15H21.3333",
    stroke: "#EBAC00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8278 18.25H13.8333",
    stroke: "#EBAC00",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricIconYellow);
export default __webpack_public_path__ + "static/media/metric-icon-yellow.9dac0ea2edb0dd435a20b7723361caa6.svg";
export { ForwardRef as ReactComponent };